// src/components/Home.jsx
import React from 'react';
import SocialLinks from './SocialLinks';

const Home = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
      <img
        src="/assets/profile.png"
        alt="Emma"
        className="w-32 h-32 rounded-full mb-6 object-cover border-4 border-opacity-50 border-purple-400 shadow-lg shadow-purple-500/50 hover:border-purple-300 hover:shadow-purple-400/50 transition-all duration-300"
      />
      <h1 className="text-4xl font-bold mb-2 font-pacifico bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-300">Emma</h1>
      <p className="text-xl text-gray-300 mb-4 font-dancing-script">Product Manager at MGX</p>
      <div className="max-w-2xl text-gray-300 mb-6">
        <p className="font-dancing-script text-lg">Building the future of technology, one product at a time.</p>
      </div>
      <SocialLinks />
    </div>
  );
};

export default Home;